import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ImageOverlay, Polyline } from '@tcc/treadstone';
import {
  currentFHAEventSubLayer,
  isTrueColorOn,
} from '../../../selectors/fhaSelectors';

export function FHAMap({ bounds, image, isInTrueColor, field }) {
  return (
    <div>
      <ImageOverlay bounds={bounds} key={bounds[1][1]} url={image} />
      {isInTrueColor ? (
        <Polyline color="white" positions={field.boundary.coordinates} />
      ) : null}
    </div>
  );
}

FHAMap.propTypes = {
  bounds: PropTypes.array,
  field: PropTypes.object,
  image: PropTypes.string,
  isInTrueColor: PropTypes.bool,
};

function mapStateToProps(state, props) {
  const event = currentFHAEventSubLayer(state, props);
  const isInTrueColor = isTrueColorOn(state, props);

  return {
    bounds: [event.northeastPoint, event.southwestPoint],
    image: event.imageUri,
    field: state.field,
    isInTrueColor,
  };
}

export default connect(mapStateToProps)(FHAMap);
